import Tag from '@doordash/component-tag';
import { IMAGE_BASE_URL } from '../../../constants/values';
import EmOnboardingStrings from './EmOnboardingStrings';
var strings = EmOnboardingStrings;
export var SetupOptionId;
(function (SetupOptionId) {
    SetupOptionId["quickStart"] = "quick-start";
    SetupOptionId["guidedSetup"] = "guided-setup";
})(SetupOptionId || (SetupOptionId = {}));
var QuickStartTile = {
    id: SetupOptionId.quickStart,
    title: strings.selection.quickStart.title(),
    description: strings.selection.quickStart.description(),
    imageUrl: IMAGE_BASE_URL + "/s/managed/consumer/teams/on-laptop-with-displays.png",
    tag: {
        icon: Tag.IconTypes.BoltLine,
        text: strings.selection.quickStart.tagText(),
        type: Tag.Types.HighlightDefault,
    },
};
var GuidedSetupTile = {
    id: SetupOptionId.guidedSetup,
    title: strings.selection.guidedSetup.title(),
    description: strings.selection.guidedSetup.description(),
    imageUrl: IMAGE_BASE_URL + "/s/managed/consumer/teams/gathering-of-people.png",
    tag: {
        icon: Tag.IconTypes.WrenchLine,
        text: strings.selection.guidedSetup.tagText(),
        type: Tag.Types.PositiveDefault,
    },
};
export var SelectionPageData = {
    title: strings.selection.title(),
    helperText: strings.selection.helperText(),
    actionText: strings.selection.continue(),
    selectionTiles: [QuickStartTile, GuidedSetupTile],
};
export var PlaceOrderOptionId;
(function (PlaceOrderOptionId) {
    PlaceOrderOptionId["single"] = "single";
    PlaceOrderOptionId["each"] = "each";
})(PlaceOrderOptionId || (PlaceOrderOptionId = {}));
export var QuickStartPageData = {
    title: strings.quickStart.title(),
    description: strings.quickStart.description(),
    budgetForm: {
        budgetName: {
            id: 'budgetName',
            label: strings.quickStart.budgetNameField.label(),
            placeholder: strings.quickStart.budgetNameField.placeholder(),
        },
        budgetAmount: {
            id: 'budgetAmount',
            labelUpTo: function (localizedAmountString) {
                return strings.quickStart.budgetAmountField.labelUpTo(localizedAmountString);
            },
            labelDefault: function (currencySymbol) {
                return strings.quickStart.budgetAmountField.labelDefault(currencySymbol);
            },
            placeholder: '20',
        },
        errors: {
            budgetNameIsRequired: strings.quickStart.budgetErrors.budgetNameIsRequired(),
            budgetAmountIsRequired: strings.quickStart.budgetErrors.budgetAmountIsRequired(),
            budgetAmountShouldBeNumber: strings.quickStart.budgetErrors.budgetAmountShouldBeNumber(),
            budgetAmountLimit: function (amountString) {
                return strings.quickStart.budgetErrors.budgetAmountLimit(amountString);
            },
            budgetNotCreatedPleaseTryAgain: function () {
                return strings.quickStart.budgetErrors.budgetNotCreatedPleaseTryAgain();
            },
        },
    },
    membersSection: {
        title: strings.quickStart.membersSectionTitle(),
        description: strings.quickStart.membersSectionDescription(),
    },
    whoWillPlaceOrderForm: {
        placeOrderField: {
            id: 'whoWillPlaceOrder',
            label: strings.quickStart.placeOrder.label(),
            placeOrderOptions: [
                {
                    id: PlaceOrderOptionId.single,
                    text: strings.quickStart.placeOrder.singlePlaceOrder(),
                },
                {
                    id: PlaceOrderOptionId.each,
                    text: strings.quickStart.placeOrder.eachPlaceOrder(),
                },
            ],
        },
        memberField: {
            id: 'members',
            label: strings.quickStart.memberField.label(),
            description: strings.quickStart.memberField.description(),
            placeholder: 'person1@company.com, person2@company.com, person3@company.com',
        },
        errors: {
            pleaseSelectOne: strings.quickStart.placeOrder.pleaseSelectOne(),
        },
    },
    paymentForm: {
        cardNumber: {
            label: strings.quickStart.cardNumberField.label(),
            description: strings.quickStart.cardNumberField.description(),
        },
        cardExpiration: {
            label: strings.quickStart.cardExpirationField.label(),
        },
        cvv: {
            label: strings.quickStart.cvcField.label(),
        },
        zipCode: {
            label: strings.quickStart.zipCodeField.label(),
        },
    },
    back: strings.quickStart.back(),
    primaryCta: strings.quickStart.createBudget(),
};
